import { useState } from 'react';
export default (function (testLocale) {
    var siteCodeFromData = typeof digitalData !== 'undefined'
        ? digitalData.page.pageInfo.siteCode
        : 'nl';
    var language = testLocale || siteCodeFromData;
    var siteCode = useState(language)[0];
    var country = useState(language === 'nl' ? 'nl' : 'be')[0];
    var translate = function (field) {
        if (!field)
            return '';
        return field[siteCode] || field.nl || '';
    };
    return { translate: translate, siteCode: siteCode, country: country };
});
